import React from "react";

const SignupForm = () => (
  <iframe
    title="Sign up"
    width="100%"
    height="800"
    style={{ border: "none" }}
    src="https://docs.google.com/forms/d/e/1FAIpQLSfAW0EtO3hM3xZm_34Z6zFAD1nSGQTTseZUcxw2Hl706yubRA/viewform"
  />
);

export default SignupForm;
